import { useState } from "react";
import {
  Anchor,
  ArrowLeftSVG,
  Button,
  CogHollowSVG,
  Icon,
} from "@newsela/angelou";
import { useRouter } from "next/router";

import {
  accountOptionAnchorCss,
  accountOptionButtonCss,
  accountOptionsContainerCss,
  accountOptionsTitleCss,
  accountOptionsUnorderedListCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutAccountOptions/PopoutAccountOptions.styles";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import getUserProperties from "@/users/getUserProperties";
import useUser, { useSignOut } from "@/users/useUser";

import { SEARCH_SESSION_KEY } from "../../../shared/constants";

export const ACCOUNT_SETTINGS_URL = "/account/settings/";

const PopoutAccountOptions = () => {
  const { push, asPath: currentPath } = useRouter();
  const { data: user } = useUser();
  const { isImpersonated } = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });
  const [isSignOutLoading, setIsSignOutLoading] = useState(false);

  const signOut = useSignOut();

  const handleAsyncSignOut = async () => {
    sessionStorage.removeItem(SEARCH_SESSION_KEY);
    await signOut();
  };

  const handleSignout = () => {
    setIsSignOutLoading(true);

    if (isImpersonated) {
      void push("/impersonate-stop");
      return;
    }

    void handleAsyncSignOut()
      .catch(() => null)
      .then(() => {
        const signInUrl = `${MONOLITH_ORIGIN}/signin`;
        const encodedRedirectUrl = encodeURIComponent(currentPath);
        const signInAndRedirectUrl = `${signInUrl}?next=${encodedRedirectUrl}`;
        void push(signInAndRedirectUrl);
      });
  };

  return (
    <div css={accountOptionsContainerCss}>
      <div css={accountOptionsTitleCss}>Manage account</div>

      <ul css={accountOptionsUnorderedListCss}>
        <li>
          <Anchor
            dataProps={{ "data-qa-selector": "global-nav-settings" }}
            href={ACCOUNT_SETTINGS_URL}
            __cssFor={accountOptionAnchorCss}
          >
            <Icon SvgComponent={CogHollowSVG} />
            Settings
          </Anchor>
        </li>

        <li>
          <Button
            onClick={handleSignout}
            __cssFor={accountOptionButtonCss}
            flavor={Button.flavors.incognito}
            dataProps={{ "data-qa-selector": "global-nav-sign-out" }}
            disabled={isSignOutLoading}
          >
            <Icon SvgComponent={ArrowLeftSVG} />
            {isImpersonated && "Stop impersonating"}
            {!isImpersonated && "Sign out"}
          </Button>
        </li>
      </ul>
    </div>
  );
};

PopoutAccountOptions.displayName = "PopoutAccountOptions";
export { PopoutAccountOptions };
